import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-awards-and-press',
  templateUrl: './awards-and-press.component.html',
  styleUrls: ['./awards-and-press.component.css']
})
export class AwardsAndPressComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
